import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import caLocale from "./ca";
import esLocale from "./es";
import enLocale from "./en";
import frLocale from "./fr";

Vue.use(VueI18n);

const messages = {
  ca: {
    ...caLocale
  },
  es: {
    ...esLocale
  },
  en: {
    ...enLocale
  },
  fr: {
    ...frLocale
  }
};

const i18n = new VueI18n({
  // set locale
  locale: Cookies.get("lang") || getLang(),
  // set locale messages
  messages
});

function getLang() {
  var lang = navigator.language || navigator.userLanguage;

  if (lang == "ca-CA") lang = "ca";
  else if (lang == "es-ES") lang = "es";
  else if (lang == "en-US" || lang == "en-EN") lang = "en";
  else if (lang == "fr-FR") lang = "fr";
  else lang = "ca";

  if (!Cookies.get("lang")) {
    Cookies.set("lang", lang);
  }

  return lang;
}

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js